/**
 * Company Leads Dashboard Service
 *
 * API service for company admin/owner leads section dashboard.
 * All routes require role: company_admin | company_owner
 *
 * Routes (all under /api/company/leads-dashboard/):
 *   GET /kpi               — 5 KPI cards (this_week, this_month, last_month)
 *   GET /today             — morning-glance tiles (created/submissions/approvals/disbursals today + stale + pipeline)
 *   GET /leaderboard       — employee performance (Activity + Processing) with sort/period/search
 *   GET /weekly-trend      — 8-week line chart (submitted vs approved)
 *   GET /rejection-reasons — top 5 rejection reasons with percentages
 *   GET /recent-activity   — last 10 mixed events feed
 *   GET /all-leads         — paginated lead list with filters
 *   GET /employee-list     — minimal list for filter dropdown
 */

import axiosInstance from '../config/axios.config';

const BASE = '/company/leads-dashboard';

export const getKpiSummary = () =>
    axiosInstance.get(`${BASE}/kpi`);

export const getTodaysActivity = () =>
    axiosInstance.get(`${BASE}/today`);

export const getLeaderboard = (params = {}) =>
    axiosInstance.get(`${BASE}/leaderboard`, { params });

export const getWeeklyTrend = () =>
    axiosInstance.get(`${BASE}/weekly-trend`);

export const getRejectionReasons = () =>
    axiosInstance.get(`${BASE}/rejection-reasons`);

export const getRecentActivity = () =>
    axiosInstance.get(`${BASE}/recent-activity`);

export const getAllLeads = (params = {}) =>
    axiosInstance.get(`${BASE}/all-leads`, { params });

export const getEmployeeList = () =>
    axiosInstance.get(`${BASE}/employee-list`);

export const getAgentLeaderboard = (params = {}) =>
    axiosInstance.get(`${BASE}/agent-leaderboard`, { params });

/**
 * Drill-down: list of leads sourced by a specific external agent.
 * Returns the same paginator shape as /api/offer-calculation/leads so
 * the response can be consumed directly by LeadsTableSection.
 *
 * Wrapped to return the same { success, data } envelope shape the
 * standalone leads page receives, so LeadsTableSection's fetch can
 * swap between the two endpoints without code changes.
 */
export const getAgentLeads = async (agentId, params = {}) => {
    const response = await axiosInstance.get(`${BASE}/agent-leads/${agentId}`, { params });
    return {
        success: !!response.data?.success,
        // Backend returns { data: { data: [...], total, current_page, last_page, per_page } }.
        // Re-wrap to match the shape getLeads() emits in offerCalculationService.
        data: response.data?.data || {},
        message: response.data?.message,
    };
};
